"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("../stdGrid");
const globals_1 = require("../../models/globals");
const boutons_1 = require("../../outils/boutons");
const brouillonsDevis_1 = require("../../models/brouillonsDevis");
class BrouillonsDevis extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "brouillonsDevis",
            datatableName: "brouillonsDevisDatatable",
            columns: brouillonsDevis_1.brouillonsDevisColumns,
            title: (0, globals_1._)("Brouillons de devis"),
            boutons: [boutons_1.ouvrirButton, boutons_1.supprimerButton],
            resizeColumn: true,
            urlData: globals_1.phpPath + "devis.php?option=listeBrouillons"
        });
    }
    ouvrir() {
        let idDoc = this.getSelectedIdDoc();
        if (idDoc > 0)
            window.location.href = "#!/pgiLayout/devis?unid=" + idDoc;
    }
    init() {
        this.currentGrid = $$("brouillonsDevisDatatable");
        // @ts-ignore
        this.currentGrid.config.footer = true;
        let me = this;
        this.currentGrid.attachEvent("onItemDblClick", function () {
            me.ouvrir();
        });
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "ouvrirButton":
                    me.ouvrir();
                    break;
                case "supprimerButton":
                    me.supprimerDocuments();
                    break;
            }
        });
    }
    ready() {
        let menu = this.$$("stdGridMenu");
        if ((globals_1.lv2.droits).includes("devis.brouillonsDevis")) {
            menu.showMenuItem("ouvrirButton");
        }
        if ((globals_1.lv2.droits).includes("devis.delete")) {
            menu.showMenuItem("supprimerButton");
        }
    }
}
exports.default = BrouillonsDevis;
